import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import relativeTime from 'dayjs/plugin/relativeTime';

// Extend dayjs with plugins
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);

/**
 * Convert UTC time to local time.
 * @param {string} utcTime - The UTC timestamp (e.g., "2025-02-03T07:44:41.840Z").
 * @param {string} format - The desired output format (default: "YYYY-MM-DD HH:mm:ss").
 * @param {string} timeZone - Optional timezone (default: user's local timezone).
 * @returns {string} - Local time as a formatted string.
 */
export const convertUtcToLocal = (utcTime: string, format = "YYYY-MM-DD HH:mm:ss", timeZone = dayjs.tz.guess()) => {
    return dayjs.utc(utcTime).tz(timeZone).format(format);
};

export const convertUtcToLocalAndRelativeTime = (utcTime: string, format = "YYYY-MM-DD HH:mm:ss", timeZone = dayjs.tz.guess()) => {
    const localTime = dayjs.utc(utcTime).tz(timeZone);
    const formattedTime = localTime.format(format);
    const relativeTimeStr = localTime.fromNow(); // Returns relative time
    return `${formattedTime} (${relativeTimeStr})`;
};


export const disabledFutureDate = (current: Dayjs | null): boolean => {
    return !!current && current.isAfter(dayjs().endOf("day"));
};